import Cumulativecalculation from './cumulativecalculation';

export default Cumulativecalculation;
